import { render, staticRenderFns } from "./ViewMail.vue?vue&type=template&id=f25b7248&"
import script from "./ViewMail.vue?vue&type=script&lang=js&"
export * from "./ViewMail.vue?vue&type=script&lang=js&"
import style0 from "./ViewMail.vue?vue&type=style&index=0&id=f25b7248&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports